/**
 * Site desenvolvido para divulgação das especializações de odontologia
 *
 * @version 1.0.0
 * @author [Renato Alves](https://github.com/renatociqueira)
 */

import React from "react";
// import Routes from "../../../routes";
import Main from "../../../Components/Main/MainComponent"
// import { useHistory } from "react-router-dom";

const Home = () => {
    // const History = useHistory();
    return(
        <Main>

        </Main>
    );

}

export default Home;